import Select from 'react-select';
import { useOvertimeReasons } from "../hooks/useOvertimeReasons";
import { OvertimeReason } from "../models/overtimeReason";

interface Props{
    name: string;
    label: string;
    value?: number;
    required: boolean;
    onChange: (name: string, value: number) => void;
}

export default function OvertimeReasonsSelector ({
    name,
    value,
    label,
    required,
    onChange
}: Props){ 
    const { data: overtimeReasons = [], isLoading, isError } = useOvertimeReasons();

    const options = overtimeReasons.map((overtimeReason: OvertimeReason) => ({
        value: overtimeReason.id.toString(),
        label: overtimeReason.name
    }))

    return (
        <div>
            <label htmlFor={name} key={`label-${name}`} className='form-label'>
                {label}
            </label>
            <Select
                isSearchable
                name={name}
                isLoading={isLoading}
                options={options}
                isClearable
                onChange={(newValue) => onChange(name, Number(newValue?.value))}
                placeholder="- Seleccione -"
                value={options.find((cc) => cc.value === (value?.toString() ?? 0))}
                required={required}
            /> 
        </div>
    );
}